import { createContext, useState } from "react";

const LoadingContext = createContext({
    isLoading: false,
    isFirstWOLoad: true,
  });

export const LoadingProvider = ({children}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isFirstWOLoad, setIsFirstWOLoad] = useState(true);

    const contextValue = {
        isLoading,
        isFirstWOLoad,
        setIsLoading,
        setIsFirstWOLoad
    }
    return (<LoadingContext.Provider value={contextValue}>
    {children}
  </LoadingContext.Provider>
)
}

export default LoadingContext;